import React, { Fragment } from "react";
import {
    BulkDeleteButton,
    ArrayInput,
    BooleanField,
    BooleanInput,
    choices,
    Create,
    Datagrid,
    DateField,
    DeleteButton,
    Edit,
    EditButton,
    List,
    ListButton,
    maxLength,
    minLength,
    minValue,
    maxValue,
    number,
    NumberInput,
    RefreshButton,
    required,
    SaveButton,
    SimpleForm,
    SimpleFormIterator,
    SelectInput,
    TextField,
    TextInput,
    Toolbar,
    TopToolbar,
    usePermissions,
} from "react-admin";
import { makeStyles } from "@mui/styles";
import EnableButton from "../Button/EnableButton";
import DisableButton from "../Button/DisableButton";

const createDefaultValues = {
    enabled: false,
};

const useStyles = makeStyles({
    toolbar: {
        display: "flex",
        justifyContent: "space-between",
    },
});

const validateBundleName = [required(), minLength(3), maxLength(64)];
const validatePlatformType = choices(["KF"], "Must be KF or others");
const validateAmount = [number(), minValue(0), maxValue(10000)];
const validateBundleItems = choices(
    ["KF_CREDITS", "KF_READING_MA_COFFEE", "KF_READING_JS_COFFEE"],
    "Must be a type"
);

const PostEditActions = ({ basePath }) => (
    <TopToolbar>
        <ListButton basePath={basePath} />
        <RefreshButton />
    </TopToolbar>
);

const CustomToolbar = (props) => (
    <Toolbar {...props} classes={useStyles()}>
        <SaveButton />
    </Toolbar>
);

const CodeBulkActionButtons = (props) => (
    <Fragment>
        <EnableButton label="Enable" {...props} />
        <DisableButton label="Disable" {...props} />
        <BulkDeleteButton {...props} />
    </Fragment>
);

export const CustomDeleteButton = (props) => (
    <DeleteButton {...props} mutationMode="pessimistic" />
);

export const BundleList = (props) => {
    const { permissions } = usePermissions();
    return (
        <List {...props} bulkActionButtons={<CodeBulkActionButtons />}>
            <Datagrid rowClick="edit">
                <TextField label="Bundle ID" source="id" />
                <TextField label="Platform" source="platform" />
                <TextField label="Name" source="name" />
                <DateField label="Date Created" source="dateCreated" showTime />
                <DateField
                    label="Date Modified"
                    source="dateModified"
                    showTime
                />
                <BooleanField label="Enabled" source="enabled" />
                {permissions === "ADMIN" && <EditButton />}
            </Datagrid>
        </List>
    );
};

export const BundleEdit = (props) => (
    <Edit actions={<PostEditActions />} {...props}>
        <SimpleForm toolbar={<CustomToolbar />}>
            <TextInput
                label="Bundle Name"
                source="name"
                validate={validateBundleName}
            />
            <ArrayInput source="items">
                <SimpleFormIterator>
                    <SelectInput
                        label="Bundle Item"
                        source="item"
                        choices={[
                            { id: "KF_CREDITS", name: "KF_CREDITS" },
                            {
                                id: "KF_READING_MA_COFFEE",
                                name: "KF_READING_MA_COFFEE",
                            },
                            {
                                id: "KF_READING_JS_COFFEE",
                                name: "KF_READING_JS_COFFEE",
                            },
                        ]}
                        validate={validateBundleItems}
                    />
                    <NumberInput
                        label="Amount"
                        source="amount"
                        validate={validateAmount}
                    />
                </SimpleFormIterator>
            </ArrayInput>
            <BooleanInput label="Enabled" source="enabled" />
        </SimpleForm>
    </Edit>
);

export const BundleCreate = (props) => (
    <Create actions={<PostEditActions />} {...props}>
        <SimpleForm initialValues={createDefaultValues} redirect="list">
            <SelectInput
                label="Platform"
                source="platform"
                choices={[{ id: "KF", name: "Kaave Fali" }]}
                validate={validatePlatformType}
            />
            <TextInput
                label="Bundle Name"
                source="name"
                validate={validateBundleName}
            />
            <ArrayInput source="items">
                <SimpleFormIterator>
                    <SelectInput
                        label="Bundle Item"
                        source="item"
                        choices={[
                            { id: "KF_CREDITS", name: "KF_CREDITS" },
                            {
                                id: "KF_READING_MA_COFFEE",
                                name: "KF_READING_MA_COFFEE",
                            },
                            {
                                id: "KF_READING_JS_COFFEE",
                                name: "KF_READING_JS_COFFEE",
                            },
                        ]}
                        validate={validateBundleItems}
                    />
                    <NumberInput
                        label="Amount"
                        source="amount"
                        validate={validateAmount}
                    />
                </SimpleFormIterator>
            </ArrayInput>
            <BooleanInput label="Enabled" source="enabled" />
        </SimpleForm>
    </Create>
);
